import { without } from 'lodash';

import {
    CHANGE_ITEM_CRYPTA_BEHAVIORAL,
    CLOSE_CRYPTA_BEHAVIORAL_EDITOR,
    CryptaBehavioralEditorAction,
    OPEN_CRYPTA_BEHAVIORAL_EDITOR,
    RESET_CRYPTA_BEHAVIORAL_EDITOR
} from '../../actions/targetings/cryptaBehavioral';
import { CryptaBehavioralEditorState } from '../../typings/audienceTargetings';
import { CryptaBehavioralEditorsState, State } from '../../typings/state';

export const defaultCryptaBehavioralEditorsState: CryptaBehavioralEditorState = {
    isOpen: false,
    checkedItems: []
};

export const cryptaBehavioralEditorsInitialState: CryptaBehavioralEditorsState = {};

export function cryptaBehavioralEditor(
    state: CryptaBehavioralEditorsState = cryptaBehavioralEditorsInitialState,
    action: CryptaBehavioralEditorAction,
    fullState: State
): CryptaBehavioralEditorsState {
    switch (action.type) {
        case OPEN_CRYPTA_BEHAVIORAL_EDITOR: {
            const editor = state[action.id] || {
                ...defaultCryptaBehavioralEditorsState
            };

            if (action.itemsId.length !== 0) {
                editor.checkedItems = action.itemsId;
            }

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: true
                }
            };
        }

        case CHANGE_ITEM_CRYPTA_BEHAVIORAL: {
            const editor = state[action.id];
            const checkedItems = editor.checkedItems;
            const itemId = action.itemId;

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    checkedItems: checkedItems.includes(itemId)
                        ? without(checkedItems, itemId)
                        : checkedItems.concat(itemId)
                }
            };
        }

        case CLOSE_CRYPTA_BEHAVIORAL_EDITOR: {
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    isOpen: false
                }
            };
        }

        case RESET_CRYPTA_BEHAVIORAL_EDITOR: {
            const newState = { ...state };
            delete newState[action.id];

            return newState;
        }

        default:
            return state;
    }
}
